import { XAxis as RechartsXAxis } from 'recharts';

export const XAxis = (
    props: React.ComponentProps<typeof RechartsXAxis>
) => {
    return <RechartsXAxis data-testid={'XAxis-container'} {...props} />;
};

export default XAxis;
